<template>
  <div class="image-background">
    <div style="margin-top: 10px">
      <h1>
        {{ $tr("helpContents.Watch.Our.Video", "Would you like to learn more about SilkPLM features? Watch our video tutorials below!") }}</h1>
    </div>
    <div class="content">
      <div class="tutorial-list-content">
        <ul class="toc">
          <li @click="toggleSection('usersRolesAndPermissions')">

            <a href="javascript:void(0)">
              <font-awesome-icon :icon="['far', 'users-gear']" size="lg" style="color: #13689c;"/>
              {{ $tr("helpContents.users.roles.permissions", "Users Roles and Permissions") }}</a>
            <ul v-if="expandedSection === 'usersRolesAndPermissions'">
              <li><a target="_blank"
                     :href="getLink('usersRolesAndPermissions')">{{ $tr("helpContents.IntroductionPermissions", "1. Introduction") }}</a>
              </li>
              <li><a target="_blank"
                     :href="getLink('usersRolesAndPermissions')">{{ $tr("helpContents.SearchingForPermissions", "2. Searching for permissions") }}</a>
              </li>
              <li><a target="_blank"
                     :href="getLink('usersRolesAndPermissions')">{{ $tr("helpContents.CreatingRole", "3. Creating a new role") }} </a>
              </li>
              <li><a target="_blank"
                     :href="getLink('usersRolesAndPermissions')">{{ $tr("helpContents.AddingPermissions", "3.1. Adding permissions") }}</a>
              </li>
              <li><a target="_blank"
                     :href="getLink('usersRolesAndPermissions')">{{ $tr("helpContents.RemovingPermissions", "3.2. Removing permissions") }}</a>
              </li>
              <li><a target="_blank"
                     :href="getLink('usersRolesAndPermissions')">{{ $tr("helpContents.AddingUserToTheSystem", "4. Adding a user to the system") }}</a>
              </li>
              <li><a target="_blank"
                     :href="getLink('usersRolesAndPermissions')">{{ $tr("helpContents.ChangingPassword", "5. Changing the password") }}</a>
              </li>
              <li><a target="_blank"
                     :href="getLink('usersRolesAndPermissions')">{{ $tr("helpContents.SubstitutionsDelegations", "6. Substitutions and Delegations") }}</a>
              </li>
            </ul>
          </li>
          <li @click="toggleSection('dynamicAttributesAndDictionaries')">

            <a href="javascript:void(0)">
              <font-awesome-icon :icon="['far', 'list-tree']" size="lg" style="color: #13689c;"/>
              {{ $tr("helpContents.dynamic.attributes", "Dynamic Attributes and Dictionaries") }}</a>
            <ul v-if="expandedSection === 'dynamicAttributesAndDictionaries'">
              <li><a target="_blank"
                  :href="getLink('dynamicAttributesAndDictionaries')">{{ $tr("helpContents.TypeDynamicAttributes", "1. Types of dynamic attributes") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('dynamicAttributesAndDictionaries')">{{ $tr("helpContents.AddingAttributesCheckbox", "2. Adding an attribute (Checkbox example)") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('dynamicAttributesAndDictionaries')">{{ $tr("helpContents.Preparing", "3. Preparing a dictionary") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('dynamicAttributesAndDictionaries')">{{ $tr("helpContents.AddingADictionary", "4. Adding a dictionary to a dynamic attribute (example)") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('dynamicAttributesAndDictionaries')">{{ $tr("helpContents.AddingAnAttribute", "5. Adding an attribute to a category (example with a dictionary)") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('dynamicAttributesAndDictionaries')">{{ $tr("helpContents.AllDictionaryAndLocations", "6. All dictionaries and their locations") }}</a>
              </li>
            </ul>
          </li>
          <li @click="toggleSection('seasons')">

            <a href="javascript:void(0)">
              <font-awesome-icon :icon="['far', 'calendar-range']" size="lg" style="color: #13689c;"/>
              {{ $tr("helpContents.Seasons", "Seasons") }}</a>
            <ul v-if="expandedSection === 'seasons'">
              <li><a target="_blank"
                  :href="getLink('seasons')">{{ $tr("helpContents.IntroductionSeason", "1. Introduction") }} </a>
              </li>
              <li><a target="_blank"
                     :href="getLink('seasons')">{{ $tr("helpContents.AddingSeason", "2. Adding seasons ") }}</a></li>
              <li><a target="_blank"
                     :href="getLink('seasons')">{{ $tr("helpContents.TabsDescription", "3. Tabs description") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('seasons')">{{ $tr("helpContents.DefiningExchange", "4. Defining exchange rates") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('seasons')">{{ $tr("helpContents.DefiningTransport", "5. Defining transport costs") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('seasons')">{{ $tr("helpContents.ImportingCoast", "6. Importing transport costs from an Excel file") }} </a>
              </li>
            </ul>
          </li>
          <li @click="toggleSection('category')">

            <a href="javascript:void(0)">
              <font-awesome-icon :icon="['far', 'books']" size="lg" style="color: #13689c;"/>
              {{ $tr("helpContents.Category", "Category") }}</a>
            <ul v-if="expandedSection === 'category'">
              <li><a target="_blank"
                  :href="getLink('category')">{{ $tr("helpContents.3level", "1. 3-level structure (examples)") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('category')">{{ $tr("helpContents.CreatingCategoryTree", "2. Creating a category tree") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('category')">{{ $tr("helpContents.DeletingCategory", "3. Deleting a category") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('category')">{{ $tr("helpContents.CategorySymbols", "4. Category symbols") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('category')">{{ $tr("helpContents.ImportingCategories", "5. Importing categories from an Excel file") }}</a>
              </li>
            </ul>
          </li>
          <li @click="toggleSection('addingContractors')">

            <a href="javascript:void(0)">
              <font-awesome-icon :icon="['far', 'user-plus']" size="lg" style="color: #13689c;"/>
              {{ $tr("helpContents.AddingContractors", "Adding Contractors") }}</a>
            <ul v-if="expandedSection === 'addingContractors'">
              <li><a target="_blank"
                  :href="getLink('addingContractors')">{{ $tr("helpContents.AddingContractorToTheSYstem", "1. Adding a contractor to the system") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('addingContractors')">{{ $tr("helpContents.CompletingDictionaries", "2. Completing dictionaries on the customer card") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('addingContractors')">{{ $tr("helpContents.PreparingExcelFile", "3. Preparing an Excel file for importing contractors") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('addingContractors')">{{ $tr("helpContents.ImportingContractors", "4. Importing contractors from an Excel file") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('addingContractors')">{{ $tr("helpContents.ExportingContractors", "5. Exporting contractors to an Excel file") }}</a>
              </li>
            </ul>
          </li>
          <li @click="toggleSection('addingEANNumbers')">

            <a href="javascript:void(0)">
              <font-awesome-icon :icon="['far', 'barcode']" size="lg" style="color: #13689c;"/>
              {{ $tr("helpContents.Adding.Ean", "Adding EAN Numbers") }}</a>
            <ul v-if="expandedSection === 'addingEANNumbers'">
              <li><a target="_blank"
                  :href="getLink('addingEANNumbers')">{{ $tr("helpContents.AddingEntiresPool", "1. Adding the entire pool of EAN numbers ") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('addingEANNumbers')">{{ $tr("helpContents.AddingSingleEan", "2. Adding a single EAN to a product using the magnifying glass") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('addingEANNumbers')">{{ $tr("helpContents.ManuallyAdding", "3. Manually adding a single EAN to a product") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('addingEANNumbers')">{{ $tr("helpContents.SearchForProducts", "4. Search for products that do not have EAN numbers assigned") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('addingEANNumbers')">{{ $tr("helpContents.BulkAssignment", "5. Bulk assignment of EAN numbers to products") }}</a>
              </li>
            </ul>
          </li>
          <li @click="toggleSection('addingProducts')">

            <a href="javascript:void(0)">
              <font-awesome-icon :icon="['far', 'boxes-stacked']" size="lg" style="color: #13689c;"/>
              {{ $tr("helpContents.AddingPoducts", "Adding products") }}</a>
            <ul v-if="expandedSection === 'addingProducts'">
              <li><a target="_blank"
                  :href="getLink('addingProducts')">{{ $tr("helpContents.DescriptionOfTabs", "1. Description of tabs and fields on the product card") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('addingProducts')">{{ $tr("helpContents.DescriptionOfDictionaries", "2. Description of dictionaries on the product card") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('addingProducts')">{{ $tr("helpContents.AddingProducts", "3. Adding products") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('addingProducts')">{{ $tr("helpContents.EditingTheProduct", "4. Editing the product tab") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('addingProducts')">{{ $tr("helpContents.AddingAGallery", "5. Adding a gallery to the product") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('addingProducts')">{{ $tr("helpContents.TaggingPhotosForm", "6. Tagging photos from the gallery") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('addingProducts')">{{ $tr("helpContents.HistoryOfChanges", "7. History of changes to the product") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('addingProducts')">{{ $tr("helpContents.ToolsUseFul", "8. Tools useful for working with a product list") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('addingProducts')">{{ $tr("helpContents.ImportProductsFromExcel", "9. Import products from an Excel file") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('addingProducts')">{{ $tr("helpContents.ExportProductToEanExcel", "10. Export products to an Excel file") }}</a>
              </li>

            </ul>
          </li>
          <li @click="toggleSection('branding')">

            <a href="javascript:void(0)">
              <font-awesome-icon :icon="['far', 'tags']" size="lg" style="color: #13689c;"/>
              {{ $tr("helpContents.Branding", "Branding") }}</a>
            <ul v-if="expandedSection === 'branding'">
              <li><a target="_blank"
                  :href="getLink('branding')">{{ $tr("helpContents.CompletingTheNecessary", "1. Completing the necessary dictionaries") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('branding')">{{ $tr("helpContents.AddingBrandingElementsSingle", "2. Adding branding elements to a single product") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('branding')">{{ $tr("helpContents.AddingBrandingElementsEntire", "3. Adding branding elements to the entire product category") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('branding')">{{ $tr("helpContents.PreviewingAllBrandingElements", "4. Previewing all branding elements entered into the system") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('branding')">{{ $tr("helpContents.GeneratingAPdf", "5. Generating a PDF file from the attached indd file") }}</a>
              </li>
            </ul>
          </li>
          <li @click="toggleSection('orders')">

            <a href="javascript:void(0)">
              <font-awesome-icon :icon="['far', 'cart-shopping']" size="lg" style="color: #13689c;"/>
              {{ $tr("helpContents.Orders", "Orders") }}</a>
            <ul v-if="expandedSection === 'orders'">
              <li><a target="_blank"
                  :href="getLink('orders')">{{ $tr("helpContents.ConditionsNecessary ", "1. Conditions necessary to place an order") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('orders')">{{ $tr("helpContents.SelectingSupplier", "2. Selecting a supplier") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('orders')">{{ $tr("helpContents.AddingProduct", "3. Adding a product to the season") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('orders')">{{ $tr("helpContents.Description", "4. Description of the tabs on the product card in the season") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('orders')">{{ $tr("helpContents.Adding", "5. Adding a price offer for a product during the season") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('orders')">{{ $tr("helpContents.Calculating", "6. Calculating the margin") }} </a>
              </li>
              <li><a target="_blank"
                     :href="getLink('orders')">{{ $tr("helpContents.Choosing", "7. Choosing the best deals") }} </a>
              </li>
              <li><a target="_blank"
                     :href="getLink('orders')">{{ $tr("helpContents.Placing ", "8. Placing orders") }} </a></li>
              <li><a target="_blank"
                     :href="getLink('orders')">{{ $tr("helpContents.ProductCard", "8.1. Product card") }} </a>
              </li>
              <li><a target="_blank"
                     :href="getLink('orders')">{{ $tr("helpContents.ProductSeason", "8.2. Product in season") }} </a>
              </li>
              <li><a target="_blank"
                     :href="getLink('orders')">{{ $tr("helpContents.NewOrder", "8.3. New order") }} </a>
              </li>
              <li><a target="_blank"
                     :href="getLink('orders')">{{ $tr("helpContents.OrderDetails", "8.4. Order details") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('orders')">{{ $tr("helpContents.TrancheAcceptance", "8.5. Tranche acceptance") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('orders')">{{ $tr("helpContents.Contracts", "9. Contracts") }} </a></li>
              <li><a target="_blank"
                  :href="getLink('orders')">{{ $tr("helpContents.GeneratingOrder", "10. Generating an order to an Excel file") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('orders')">{{ $tr("helpContents.GeneratingBranding", "11. Generating a branding package") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('orders')">{{ $tr("helpContents.GeneratingDataThatWeCanChangeDuring", "12. Data that we can change during the order processing") }} </a>
              </li>
            </ul>
          </li>
          <li @click="toggleSection('logisticsModule')">

            <a href="javascript:void(0)">
              <font-awesome-icon :icon="['far', 'truck']" size="lg" style="color: #13689c;"/>
              {{ $tr("helpContents.LogisticsModule", "Logistics Module") }}</a>
            <ul v-if="expandedSection === 'logisticsModule'">
              <li><a target="_blank"
                  :href="getLink('logisticsModule')">{{ $tr("helpContents.IntroductionLogisticModule", "1. Introduction") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('logisticsModule')">{{ $tr("helpContents.AcceptanceOrder", "2. Acceptance of the order tranche’s shipment") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('logisticsModule')">{{ $tr("helpContents.DescriptionLogistics", "3. Description of the Logistics Module") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('logisticsModule')">{{ $tr("helpContents.CombiningTranches ", "4. Combining tranches (example)") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('logisticsModule')">{{ $tr("helpContents.SplittingTranches", "5. Splitting tranches (example)") }}</a>
              </li>

            </ul>
          </li>
          <li @click="toggleSection('transportExchangeLogistics')">

            <a href="javascript:void(0)">
              <font-awesome-icon :icon="['far', 'ship']" size="lg" style="color: #13689c;"/>
              {{ $tr("helpContents.Logistics", "Transport Exchange - Logistics") }}</a>
            <ul v-if="expandedSection === 'transportExchangeLogistics'">
              <li><a target="_blank"
                  :href="getLink('transportExchangeLogistics')">{{ $tr("helpContents.IntroductionAddingCompanyEmail", "1. Introduction (adding a company email)") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('transportExchangeLogistics')">{{ $tr("helpContents.InvitingForwardersToTheTransport", "2. Inviting forwarders to the transport exchange") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('transportExchangeLogistics')">{{ $tr("helpContents.SendingInquiries", "3. Sending inquiries") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('transportExchangeLogistics')">{{ $tr("helpContents.SelectingBest", "4. Selecting the best offers") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('transportExchangeLogistics')">{{ $tr("helpContents.WeeklyDeals", "5. Weekly deals on selected containers") }}</a>
              </li>
            </ul>
          </li>
          <li @click="toggleSection('transportExchangeForwarder')">

            <a href="javascript:void(0)">
              <font-awesome-icon :icon="['far', 'user-headset']" size="lg" style="color: #13689c;"/>
              {{ $tr("helpContents.Forwarder", "Transport Exchange - Forwarder") }}</a>
            <ul v-if="expandedSection === 'transportExchangeForwarder'">
              <li><a target="_blank"
                  :href="getLink('transportExchangeForwarder')">{{ $tr("helpContents.FirstLogin", "1. First login to the system") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('transportExchangeForwarder')">{{ $tr("helpContents.EachTimeYou", "2. Each time you log in to the system") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('transportExchangeForwarder')">{{ $tr("helpContents.DescriptionSystemElements", "3.1. Description of system elements") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('transportExchangeForwarder')">{{ $tr("helpContents.Modules", "3.2. Modules") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('transportExchangeForwarder')">{{ $tr("helpContents.ChangingOrder", "4. Changing the order of the field view") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('transportExchangeForwarder')">{{ $tr("helpContents.ChangePassword", "5. Change Password") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('transportExchangeForwarder')">{{ $tr("helpContents.CompletingTheCurrencies", "6. Completing the “Currencies” dictionary") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('transportExchangeForwarder')">{{ $tr("helpContents.ViewingInquiries", "7. Viewing inquiries ") }}</a>
              </li>
              <li><a target="_blank"
                  :href="getLink('transportExchangeForwarder')">{{ $tr("helpContents.endingPriceOffer", "8.1. Sending a price offer for a specific inquiry") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('transportExchangeForwarder')">{{ $tr("helpContents.NotificationsRegarding", "8.2. Notifications regarding the sent offer ") }} </a>
              </li>
              <li><a target="_blank"
                  :href="getLink('transportExchangeForwarder')">{{ $tr("helpContents.SendingWeekly", "9. Sending weekly offers") }} </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="illustration">
        <img src="https://silkplm.com/wp-content/uploads/2024/05/Sekcje-tutoriale.svg" alt="">
      </div>
    </div>
    <h1>
      {{ $tr("helpContents.NeedMoreInformation", "Need more information? Contact us via Slack on the support channel!") }}
    </h1>
  </div>
</template>

<script>
import Activity from "@/activity/Activity";

export default {
  name: "HelpContents",
  data() {
    return {
      expandedSection: null,
      language: AppTranslations.selectedLang === 'pl' ? 'pl' : 'en',
      links: {
        en: {
          usersRolesAndPermissions: 'https://trainingpreview.edapp.com/p/I0tbo7uHu0OdrH4bo9GM9By7',
          dynamicAttributesAndDictionaries: 'https://trainingpreview.edapp.com/p/hPhsw2Rz9KlHXFu5b75yC0H8',
          seasons: 'https://trainingpreview.edapp.com/p/vzqn5omOM4WUHvur012lXcSM',
          category: 'https://trainingpreview.edapp.com/p/ZwZEzhHhoHWc14i8wPZrinYz',
          addingContractors: 'https://trainingpreview.edapp.com/p/EXyzy49RFGVTmKWwWrvF0AMJ',
          addingEANNumbers: 'https://trainingpreview.edapp.com/p/80BZqdOqdH0vkHbevX3bjwmh',
          addingProducts: 'https://trainingpreview.edapp.com/p/4vMngRt0pXhDipP8YnZ7tcET',
          branding: 'https://trainingpreview.edapp.com/p/mcN88iIcSnh66e0F0xmVjSLe',
          orders: 'https://trainingpreview.edapp.com/p/kjMx59NoWuyAszH0xQ3XIHL3',
          logisticsModule: 'https://trainingpreview.edapp.com/p/vpWqtruw9YV4gpLGtDRvYbZ6',
          transportExchangeLogistics: 'https://trainingpreview.edapp.com/p/z5L5yKwkdIqFvhncB2PWh4yo',
          transportExchangeForwarder: 'https://trainingpreview.edapp.com/p/yHThD6tNBzDjBfOIQLMNvyST',
        },
        pl: {
          usersRolesAndPermissions: 'https://trainingpreview.edapp.com/p/Sibkm44pr3Ts4idJfKpzLdcA',
          dynamicAttributesAndDictionaries: 'https://trainingpreview.edapp.com/p/mzqqWqNIUAEWXGtZ1SlrcX3n',
          seasons: 'https://trainingpreview.edapp.com/p/cuG90qbIrSmw88JnzwAzu15l',
          category: 'https://trainingpreview.edapp.com/p/RM5sLBA8Mo7pPJHXDxFe4rsP',
          addingContractors: 'https://trainingpreview.edapp.com/p/wbv9LtE48XTuL1EawpjFm27I',
          addingEANNumbers: 'https://trainingpreview.edapp.com/p/pztVpKQe',
          addingProducts: 'https://trainingpreview.edapp.com/p/azZtWNQDGt9JO1RVoIKzU8Yt',
          branding: 'https://trainingpreview.edapp.com/p/lM99kV3MK1F5knSKpgHiNdZu',
          orders: 'https://trainingpreview.edapp.com/p/qTzFnLD2KPr2TvUEKLkfbXTe',
          logisticsModule: 'https://trainingpreview.edapp.com/p/F8Daio5VvdIUbdAiymDk2d0K',
          transportExchangeLogistics: 'https://trainingpreview.edapp.com/p/PEHtYptLHuPTo9BAXOYV2k2W',
          transportExchangeForwarder: 'https://trainingpreview.edapp.com/p/p576XVdeqOuD32FGU7If9LgS',
        }
      }
    };
  },
  methods: {
    ...Activity.methods,
    getTitle() {
      return this.$tr('helpContents.InstructionsAndSupport', 'Instructions and Support');
    },
    getLink(section) {
      return this.links[this.language][section] || '#';
    },
    toggleSection(section) {
      this.expandedSection = this.expandedSection === section ? null : section;
    }
  },
  watch: {}
};
</script>

<style scoped>

.image-background {
  margin: 0;
  padding: 0;
  height: 80vh;
  background-image: url("https://silkplm.com/wp-content/uploads/2024/05/Background-1.svg");
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-position: center;
}

.content {
  display: flex;
  text-align: left;
  justify-content: space-between;
  padding: 1%;
}

.tutorial-list-content {
  flex-basis: 30%;
}

.illustration img {
  max-width: 500px;
  margin-top: 90px;
  margin-right: 30px;
}

li svg {
  padding-bottom: 1px;
  padding-right: 12px;
}

h1 {
  text-align: center;
  margin-bottom: 20px;
  font-size: 24px;
}

.toc {
  list-style-type: none;
  padding: 0;
}

.toc li {
  text-align: left;
  cursor: pointer;
  list-style-type: none;

}

.toc > li:nth-child(2n) > a {
  background-color: #F3F9FF;
}

.toc a {
  display: block;
  text-decoration: none;
  padding: 14px 20px;
  color: #13689c;
  font-size: 15px;
  transition: background-color 0.3s ease;
}

.toc li a:hover {
  background-color: #D7F0FF;
}

@media screen  and (max-height: 900px){
  .toc a {
    padding: 10px 10px;
    font-size: 13px;
  }

  .illustration img {
    margin-top: 40px;
    height: 400px;
    width: 344px;
  }

  h1 {
    font-size: 20px;
  }

}

@media screen  and (max-height: 750px){

  .toc a {
    padding: 7px 7px;
    font-size: 12px;
  }
  .illustration img {
    margin-top: 20px;
    height: 300px;
    width: 244px;
  }
  h1 {
    font-size: 18px;
  }

}

@media screen and (max-width: 1250px) {
  .illustration img {
    display: none;
  }

  .tutorial-list-content {
    flex-basis: 100%;
  }
}


</style>
